import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_BASE_HREF, DatePipe, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';

import { AppComponent } from './app.component';

import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule } from './shared/navbar/navbar.module';
import { FixedpluginModule } from './shared/fixedplugin/fixedplugin.module';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';

import { AppRoutes } from './app.routing';
import { MessagesComponent } from './messages/messages/messages.component';
//import { AuthDirective } from './auth.directive';
import { AuthGuard } from './auth.guard';
import { IndexServiciosComponent } from './administration/services/index-servicios.component';
import { FormServiciosComponent } from './administration/services/form-servicios.component';
import { IndexSurchargesComponent } from './fees/surcharges/index-surcharges/index-surcharges.component';
import { FormSurchargesComponent } from './fees/surcharges/form-surcharges/form-surcharges.component';
import { UsersListComponent } from './users/users-list.component';
import { UsersFormComponent } from './users/users-form.component';
import { RolesListComponent } from './roles/roles-list.component';
import { RolesFormComponent } from './roles/roles-form.component';
import { PlaidComponent } from './plaid/plaid.component';
import { DriverComponent } from './driver/driver.component';
import { FeesComponent } from './fees/fees.component';
import { StripeComponent } from './stripe/stripe.component';
import { DriverFormComponent } from './driver/driver-form.component';
import { CustomersListComponent } from './customers/customers-list.component';
import { CustomersFormComponent } from './customers/customers-form.component';
import { LogisticsListComponent } from './logistics/logistics-list.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { ContactsFormComponent } from './invoices/contacts/contacts-form/contacts-form.component';
import { ContactsListComponent } from './invoices/contacts/contacts-list/contacts-list.component';
import { ItemsListComponent } from './invoices/items/items-list/items-list.component';
import { ItemsFormComponent } from './invoices/items/items-form/items-form.component';
import { InvoicesListComponent } from './invoices/invoices-list.component';
import { PaypalComponent } from './paypal/paypal.component';
import { AccountingComponent } from './accounting/accounting.component';
import { AccountingFormComponent } from './accounting/accounting-form/accounting-form.component';
import { ConfigsListComponent } from './configs/configs-list.component';
import { ConfigsFormComponent } from './configs/configs-form.component';
import { CourierChargesListComponent } from './fees/courierCharges/courier-charges-list/courier-charges-list.component';
import { CourierChargesFormComponent } from './fees/courierCharges/courier-charges-form/courier-charges-form.component';
import { TaskChargesFormComponent } from './fees/taskCharges/task-charges-form/task-charges-form.component';
import { TaskChargesListComponent } from './fees/taskCharges/task-charges-list/task-charges-list.component';
import { PersonnelFormComponent } from './accounting/personnel/personnel-form/personnel-form.component';
import { PersonnelListComponent } from './accounting/personnel/personnel-list/personnel-list.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DriverCourierListComponent } from './fees/driverFees/driver-courier-list/driver-courier-list.component';
import { DriverCourierFormComponent } from './fees/driverFees/driver-courier-form/driver-courier-form.component';
import { DriverTaskListComponent } from './fees/driverFees/driver-task-list/driver-task-list.component';
import { DriverTaskFormComponent } from './fees/driverFees/driver-task-form/driver-task-form.component';
import { HelcimComponent } from './helcim/helcim.component';
import { SquareComponent } from './square/square.component';
import { HumanPersonnelFormComponent } from './human-resources/human-personnel/human-personnel-form/human-personnel-form.component';
import { HumanPersonnelListComponent } from './human-resources/human-personnel/human-personnel-list/human-personnel-list.component';
import { VolumeChargesListComponent } from './fees/volumeCharges/volume-charges-list/volume-charges-list.component';
import { VolumeChargesFormComponent } from './fees/volumeCharges/volume-charges-form/volume-charges-form.component';
import { WeightChargesFormComponent } from './fees/weightCharges/weight-charges-form/weight-charges-form.component';
import { WeightChargesListComponent } from './fees/weightCharges/weight-charges-list/weight-charges-list.component';
import { DriverVolumeFormComponent } from './fees/driverFees/driver-volume-form/driver-volume-form.component';
import { DriverVolumeListComponent } from './fees/driverFees/driver-volume-list/driver-volume-list.component';
import { DriverWeightListComponent } from './fees/driverFees/driver-weight-list/driver-weight-list.component';
import { DriverWeightFormComponent } from './fees/driverFees/driver-weight-form/driver-weight-form.component';
import { MarketingListComponent } from './marketing/marketing-list/marketing-list.component';
import { ToolkitListComponent } from './human-resources/toolkit/toolkit-list/toolkit-list.component';
import { WpBotFormComponent } from './hub/wpBot/wp-bot-form/wp-bot-form.component';
import { WpBotListComponent } from './hub/wpBot/wp-bot-list/wp-bot-list.component';
import { ChatBotListComponent } from './hub/chatBot/chat-bot-list/chat-bot-list.component';
import { ChatBotFormComponent } from './hub/chatBot/chat-bot-form/chat-bot-form.component';
import { CompanyListComponent } from './company/company-list/company-list.component';
import { MerchantComponent } from './merchant/merchant.component';
import { AnalysisComponent } from './analysis/analysis.component';
import { EmmChargesFormComponent } from './fees/emmCharges/emm-charges-form/emm-charges-form.component';
import { EmmChargesListComponent } from './fees/emmCharges/emm-charges-list/emm-charges-list.component';
import { DriverEmmFormComponent } from './fees/driverFees/driver-emm-form/driver-emm-form.component';
import { DriverEmmListComponent } from './fees/driverFees/driver-emm-list/driver-emm-list.component';
import { AdsComponent } from './marketing/ads/ads.component';
import { QbExpenseFormComponent } from './quickbooks/quickbooksExpense/qb-expense-form/qb-expense-form.component';
import { QbExpenseListComponent } from './quickbooks/quickbooksExpense/qb-expense-list/qb-expense-list.component';
import { QbVendorListComponent } from './quickbooks/quickbooksVendors/qb-vendor-list/qb-vendor-list.component';
import { QbVendorFormComponent } from './quickbooks/quickbooksVendors/qb-vendor-form/qb-vendor-form.component';
import { DocsFormComponent } from './docs/docs-form/docs-form.component';
import { DocsListComponent } from './docs/docs-list/docs-list.component';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { CategoriesFormComponent } from './categories/categories-form.component';
import { CategoriesListComponent } from './categories/categories-list.component';
import { SocialComponent } from './marketing/social/social.component';
import { MediaroomComponent } from './marketing/mediaroom/mediaroom.component';
import { ObsMarketingComponent } from './observability/obs-marketing/obs-marketing.component';
import { ObsAdsComponent } from './observability/obs-ads/obs-ads.component';
import { ObsSocialComponent } from './observability/obs-social/obs-social.component';
import { ObsSocialAuditComponent } from './observability/obs-social/audits/obs-social-audit.component';
import { ObsSocialExecutiveComponent } from './observability/obs-social/executive/obs-social-executive.component';
import { ObsSocialLeadsComponent } from './observability/obs-social/leads/obs-social-leads.component';
import { ObsMediaroomComponent } from './observability/obs-mediaroom/obs-mediaroom.component';
import { ObsLogisticsComponent } from './observability/obs-logistics/obs-logistics.component';
import { ObsAccountingComponent } from './observability/obs-accounting/obs-accounting.component';
import { ObsFinanceComponent } from './observability/obs-finance/obs-finance.component';
import { ObsHrComponent } from './observability/obs-hr/obs-hr.component';
import { SeoRegistryListComponent } from './marketing/seo/seo-registry/seo-registry-list/seo-registry-list.component';
import { SeoRegistryFormComponent } from './marketing/seo/seo-registry/seo-registry-form/seo-registry-form.component';
import { SeoMetricsDailyListComponent } from './marketing/seo/seoMetricsDaily/seo-metrics-daily-list/seo-metrics-daily-list.component';
import { SeoActionsBacklogListComponent } from './marketing/seo/seo-actions-backlog/seo-actions-backlog-list/seo-actions-backlog-list.component';
import { SeoMetricsWeeklyListComponent } from './marketing/seo/seo-metrics-weekly/seo-metrics-weekly-list/seo-metrics-weekly-list.component';
import { QaRunFormComponent } from './marketing/seo/qa-run/qa-run-form/qa-run-form.component';
import { QaRunListComponent } from './marketing/seo/qa-run/qa-run-list/qa-run-list.component';
import { InternalLinksListComponent } from './marketing/seo/internal-links/internal-links-list/internal-links-list.component';
import { SeoOffPageCampaignsListComponent } from './marketing/seo/seo-off-page-campaigns/seo-off-page-campaigns-list/seo-off-page-campaigns-list.component';
import { SeoOffPageCampaignsFormComponent } from './marketing/seo/seo-off-page-campaigns/seo-off-page-campaigns-form/seo-off-page-campaigns-form.component';
import { SeoOffPageRecommendationsListComponent } from './marketing/seo/seo-off-page-recommendations/seo-off-page-recommendations-list/seo-off-page-recommendations-list.component';
import { SeoOffPageRecommendationsFormComponent } from './marketing/seo/seo-off-page-recommendations/seo-off-page-recommendations-form/seo-off-page-recommendations-form.component';
import { SeoOffPageProspectsListComponent } from './marketing/seo/seo-off-page-prospects/seo-off-page-prospects-list/seo-off-page-prospects-list.component';
import { SeoOffPageProspectsFormComponent } from './marketing/seo/seo-off-page-prospects/seo-off-page-prospects-form/seo-off-page-prospects-form.component';
import { SeoOffPageBacklinksListComponent } from './marketing/seo/seo-off-page-backlinks/seo-off-page-backlinks-list/seo-off-page-backlinks-list.component';
import { SeoOffPageBacklinksFormComponent } from './marketing/seo/seo-off-page-backlinks/seo-off-page-backlinks-form/seo-off-page-backlinks-form.component';
import { SeoOffPageInsightsComponent } from './marketing/seo/seo-off-page-insights/seo-off-page-insights.component';
import { SeoOffPageDashboardComponent } from './marketing/seo/seo-off-page-dashboard/seo-off-page-dashboard.component';
import { MediaRoomRegistryListComponent } from './marketing/mediaroom/mediaroom-registry/mediaroom-registry-list/mediaroom-registry-list.component';
import { MediaRoomRegistryFormComponent } from './marketing/mediaroom/mediaroom-registry/mediaroom-registry-form/mediaroom-registry-form.component';
import { MediaRoomVersionDetailModalComponent } from './marketing/mediaroom/mediaroom-registry/mediaroom-registry-list/mediaroom-version-detail-modal.component';
import { SeoCannibalClusterListComponent } from './observability/seo/seo-cannibal-cluster/seo-cannibal-cluster-list.component';
import { SeoCannibalClusterFormComponent } from './observability/seo/seo-cannibal-cluster/seo-cannibal-cluster-form.component';
import { SeoCannibalEdgeListComponent } from './observability/seo/seo-cannibal-edge/seo-cannibal-edge-list.component';
import { GbpLocationsListComponent } from './observability/seo/local-seo/locations/locations-page.component';
import { GbpLocationMappingModalComponent } from './observability/seo/local-seo/locations/location-mapping-modal.component';
import { GbpReviewsInboxComponent } from './observability/seo/local-seo/reviews/reviews-inbox-page.component';
import { GbpReviewDetailDrawerComponent } from './observability/seo/local-seo/reviews/review-detail-drawer.component';
import { LocalActionsQueueComponent } from './observability/seo/local-seo/actions/actions-queue-page.component';
import { OffPagePerformanceListComponent } from './observability/seo/off-page-performance/off-page-performance-list.component';
import { OffPagePerformanceDetailComponent } from './observability/seo/off-page-performance/off-page-performance-detail.component';
import { SeoKeywordInsightListComponent } from './observability/seo/seo-keyword-insight/seo-keyword-insight-list.component';
import { SeoKeywordInsightDetailComponent } from './observability/seo/seo-keyword-insight/seo-keyword-insight-detail.component';
import { SocialContentRequestListComponent } from './marketing/social/social-content-request/social-content-request-list/social-content-request-list.component';
import { SocialContentRequestFormComponent } from './marketing/social/social-content-request/social-content-request-form/social-content-request-form.component';
import { SocialRegistryListComponent } from './marketing/social/social-registry/social-registry-list/social-registry-list.component';
import { SocialRegistryFormComponent } from './marketing/social/social-registry/social-registry-form/social-registry-form.component';

import { SitemapAuditsPageComponent } from './observability/seo/sitemap-audits/sitemap-audits-page.component';
import { SitemapDashboardCardsComponent } from './observability/seo/sitemap-audits/sitemap-dashboard-cards.component';
import { SitemapIssuesTableComponent } from './observability/seo/sitemap-audits/sitemap-issues-table.component';
import { SitemapMissingUrlsComponent } from './observability/seo/sitemap-audits/sitemap-missing-urls.component';
import { SitemapHistoryComponent } from './observability/seo/sitemap-audits/sitemap-history.component';
import { SeoActionDetailModalComponent } from './marketing/seo/seo-actions-backlog/seo-actions-backlog-list/seo-action-detail-modal.component';
import { SeoOffPageCampaignsReviewsComponent } from './marketing/seo/seo-off-page-campaigns/seo-off-page-campaigns-reviews/seo-off-page-campaigns-reviews.component';
import { UrlMappingComponent } from './marketing/seo/seo-off-page-campaigns/url-mapping/url-mapping.component';
import { OnPageComponent } from './marketing/seo/on-page/on-page.component';
import { InternalLinksComponent } from './marketing/seo/internal-links/internal-links/internal-links.component';
import { TechnicalQaComponent } from './marketing/seo/technical-qa/technical-qa.component';
import { LocalSeoComponent } from './marketing/seo/local-seo/local-seo.component';
import { OffPageComponent } from './marketing/seo/off-page/off-page.component';
import { PerformanceComponent } from './marketing/seo/performance/performance.component';
import { RegistryComponent } from './marketing/registry/registry/registry.component';
import { SemantikaComponent } from './marketing/social/semantika/semantika/semantika.component';
import { StrategyComponent } from './marketing/social/strategy/strategy/strategy.component';
import { PerformanceSocialComponent } from './marketing/social/performance-social/performance-social.component';
import { RequestIntakeComponent } from './marketing/social/request-intake/request-intake.component';
import { MroomsocialComponent } from './marketing/mediaroom/social/mroomsocial/mroomsocial.component';

//const config: SocketIoConfig = { url: "http://localhost:2021/", options: {} };
/* const config: SocketIoConfig = {
  url: "http://206.81.1.106:2021/",
  options: {},
}; */

const config: SocketIoConfig = {
  url: 'https://socket.courierandbeyond.com/',
  options: {},
};

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatStepperModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatDatepickerModule,
    MatButtonModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatNativeDateModule,
  ],
  declarations: [],
})
export class MaterialModule {}

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: false,
    }),
    HttpClientModule,
    MaterialModule,
    SidebarModule,
    NavbarModule,
    FooterModule,
    FixedpluginModule,
    SocketIoModule.forRoot(config),
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    IndexServiciosComponent,
    FormServiciosComponent,
    IndexSurchargesComponent,
    FormSurchargesComponent,
    MessagesComponent,
    //AuthDirective,
    UsersListComponent,
    UsersFormComponent,
    RolesListComponent,
    RolesFormComponent,
    ConfigsListComponent,
    ConfigsFormComponent,
    PlaidComponent,
    FeesComponent,
    StripeComponent,
    DriverComponent,
    DriverFormComponent,
    CustomersListComponent,
    CustomersFormComponent,
    LogisticsListComponent,
    EditProfileComponent,
    InvoicesComponent,
    ContactsFormComponent,
    ContactsListComponent,
    ItemsListComponent,
    ItemsFormComponent,
    InvoicesListComponent,
    PaypalComponent,
    AccountingComponent,
    AccountingFormComponent,
    CourierChargesListComponent,
    CourierChargesFormComponent,
    TaskChargesFormComponent,
    TaskChargesListComponent,
    PersonnelFormComponent,
    PersonnelListComponent,
    ForgotPasswordComponent,
    DriverCourierListComponent,
    DriverCourierFormComponent,
    DriverTaskListComponent,
    DriverTaskFormComponent,
    HelcimComponent,
    SquareComponent,
    HumanPersonnelFormComponent,
    HumanPersonnelListComponent,
    VolumeChargesListComponent,
    VolumeChargesFormComponent,
    WeightChargesFormComponent,
    WeightChargesListComponent,
    DriverVolumeFormComponent,
    DriverVolumeListComponent,
    DriverWeightListComponent,
    DriverWeightFormComponent,
    MarketingListComponent,
    ToolkitListComponent,
    WpBotFormComponent,
    WpBotListComponent,
    ChatBotListComponent,
    ChatBotFormComponent,
    CompanyListComponent,
    MerchantComponent,
    AnalysisComponent,
    EmmChargesFormComponent,
    EmmChargesListComponent,
    DriverEmmFormComponent,
    DriverEmmListComponent,
    AdsComponent,
    QbExpenseFormComponent,
    QbExpenseListComponent,
    QbVendorListComponent,
    QbVendorFormComponent,
    DocsFormComponent,
    DocsListComponent,
    CategoriesFormComponent,
    CategoriesListComponent,
    SocialComponent,
    MediaroomComponent,
    ObsMarketingComponent,
    ObsAdsComponent,
    ObsSocialComponent,
    ObsSocialAuditComponent,
    ObsSocialExecutiveComponent,
    ObsSocialLeadsComponent,
    ObsMediaroomComponent,
    ObsLogisticsComponent,
    ObsAccountingComponent,
    ObsFinanceComponent,
    ObsHrComponent,
    SeoRegistryListComponent,
    SeoRegistryFormComponent,
    SeoMetricsDailyListComponent,
    SeoActionsBacklogListComponent,
    SeoMetricsWeeklyListComponent,
    QaRunFormComponent,
    QaRunListComponent,
    InternalLinksListComponent,
    InternalLinksComponent,
    SeoOffPageCampaignsListComponent,
    SeoOffPageCampaignsFormComponent,
    SeoOffPageCampaignsReviewsComponent,
    UrlMappingComponent,
    OnPageComponent,
    TechnicalQaComponent,
    SeoOffPageRecommendationsListComponent,
    SeoOffPageRecommendationsFormComponent,
    SeoOffPageProspectsListComponent,
    SeoOffPageProspectsFormComponent,
    SeoOffPageBacklinksListComponent,
    SeoOffPageBacklinksFormComponent,
    SeoOffPageInsightsComponent,
    SeoOffPageDashboardComponent,
    MediaRoomRegistryListComponent,
    MediaRoomRegistryFormComponent,
    MediaRoomVersionDetailModalComponent,
    SeoCannibalClusterListComponent,
    SeoCannibalClusterFormComponent,
    SeoCannibalEdgeListComponent,
    GbpLocationsListComponent,
    GbpLocationMappingModalComponent,
    GbpReviewsInboxComponent,
    GbpReviewDetailDrawerComponent,
    LocalActionsQueueComponent,
    OffPagePerformanceListComponent,
    OffPagePerformanceDetailComponent,
    SeoKeywordInsightListComponent,
    SeoKeywordInsightDetailComponent,
    SitemapAuditsPageComponent,
    SitemapDashboardCardsComponent,
    SitemapIssuesTableComponent,
    SitemapMissingUrlsComponent,
    SitemapHistoryComponent,
    SeoActionDetailModalComponent,
    SocialContentRequestListComponent,
    SocialContentRequestFormComponent,
    SocialRegistryListComponent,
    SocialRegistryFormComponent,
    LocalSeoComponent,
    OffPageComponent,
    PerformanceComponent,
    RegistryComponent,
    SemantikaComponent,
    StrategyComponent,
    PerformanceSocialComponent,
    RequestIntakeComponent,
    MroomsocialComponent,
  ],
  providers: [
    AuthGuard,
    { provide: APP_BASE_HREF, useValue: '/' },
    DatePipe,
    TitleCasePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
